import { Modal } from 'antd';
import styled from 'styled-components';
import { settingsControlStyles } from './controlStyles';

/** 본문 밖에 열리는 확인/이력 모달도 동일한 컨트롤 크기와 여백을 사용한다. */
export const SettingsModal = styled(Modal)`
  ${settingsControlStyles}
  .ant-modal-content {
    padding: 24px;
  }
  .ant-modal-header {
    margin-bottom: 20px;
  }
  .ant-modal-footer {
    margin-top: 24px;
    padding-top: 16px;
  }
  .ant-modal-close,
  .ant-modal-close-x {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`;
